/*
  Menu da telefono (snippets/menu-telefono.liquid).
  Estende HeaderDrawer di global.js, che fa gia' tutto il resto: misura dove finisce la
  testata, blocca lo scorrimento della pagina, tiene la testata visibile, chiude con Esc
  e con un tocco sul velo. Qui cambia solo cosa succede dentro il cassetto: al posto dei
  sottomenu di Dawn che scorrono di lato, pannelli che si sostituiscono con una
  dissolvenza e voci che arrivano in cascata (i tempi sono in menu-telefono.css).
*/
if (!customElements.get('menu-telefono') && typeof HeaderDrawer !== 'undefined') {
  class MenuTelefono extends HeaderDrawer {
    // MenuDrawer collega un "chiudi sottomenu" a ogni <button> interno: qui i bottoni
    // aprono e chiudono i pannelli, quindi il collegamento lo facciamo noi.
    bindEvents() {
      this.summary = this.querySelector('summary');
      this.cassetto = this.querySelector('.mt-cassetto');
      this.pannelli = Array.from(this.querySelectorAll('[data-mt-pannello]'));

      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      this.querySelectorAll('[data-mt-apri]').forEach((bottone) =>
        bottone.addEventListener('click', this.onApriClick.bind(this))
      );
      this.querySelectorAll('[data-mt-indietro]').forEach((bottone) =>
        bottone.addEventListener('click', this.tornaAlMenu.bind(this))
      );
    }

    openMenuDrawer(summaryElement) {
      clearTimeout(this.timerRiordino);
      this.mostra('principale');
      super.openMenuDrawer(summaryElement);
    }

    closeMenuDrawer(event, elementToFocus) {
      if (!elementToFocus) return;
      super.closeMenuDrawer(event, elementToFocus);
      this.summary.setAttribute('aria-expanded', 'false');
      clearTimeout(this.timerPremuto);
      clearTimeout(this.timerRiordino);
      // A cassetto uscito (400 ms, come closeAnimation) si riparte dall'elenco principale
      this.timerRiordino = setTimeout(() => this.mostra('principale'), 420);
    }

    onKeyUp(event) {
      if (event.code?.toUpperCase() !== 'ESCAPE' || !this.mainDetailsToggle.hasAttribute('open')) return;
      if (this.attivo && this.attivo !== 'principale') {
        this.tornaAlMenu();
      } else {
        this.closeMenuDrawer(event, this.summary);
        this.summary.focus();
      }
    }

    onApriClick(event) {
      const bottone = event.currentTarget;
      // La riga resta evidenziata un istante prima del cambio, come su Wovo
      bottone.classList.add('is-premuto');
      clearTimeout(this.timerPremuto);
      this.timerPremuto = setTimeout(() => {
        bottone.classList.remove('is-premuto');
        this.mostra(bottone.dataset.mtApri);
        const indietro = this.pannello(bottone.dataset.mtApri)?.querySelector('[data-mt-indietro]');
        if (indietro) trapFocus(this.mainDetailsToggle, indietro);
      }, 120);
    }

    tornaAlMenu() {
      const da = this.attivo;
      this.mostra('principale', true);
      const bottone = this.querySelector(`[data-mt-apri="${da}"]`);
      if (bottone) trapFocus(this.mainDetailsToggle, bottone);
    }

    pannello(id) {
      return this.pannelli.find((pannello) => pannello.dataset.mtPannello === id);
    }

    mostra(id, indietro = false) {
      this.attivo = id;
      this.cassetto.classList.toggle('mt-da-indietro', indietro);
      this.querySelectorAll('[data-mt-apri]').forEach((bottone) =>
        bottone.setAttribute('aria-expanded', bottone.dataset.mtApri === id ? 'true' : 'false')
      );
      this.pannelli.forEach((pannello) => {
        const attivo = pannello.dataset.mtPannello === id;
        pannello.classList.toggle('is-attivo', attivo);
        pannello.inert = !attivo;
        // Ogni categoria si riapre dall'inizio dell'elenco
        if (attivo && id !== 'principale') {
          const lista = pannello.querySelector('.mt-sotto-lista');
          if (lista) lista.scrollTop = 0;
        }
      });
    }
  }

  customElements.define('menu-telefono', MenuTelefono);
}
